/** The project's configured custom domain. All canonical URLs derive from this one constant. */
export const SITE_ORIGIN = 'https://whatsizeairpurifier.com';
export const SITE_NAME = 'What Size Air Purifier';
export const canonical = (path: string) => `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
